export default __webpack_public_path__ + "static/media/calagracioneta.49f587c9.jpg";